import { render, staticRenderFns } from "./VendorInvoices.vue?vue&type=template&id=e30a9b9c&"
import script from "./VendorInvoices.vue?vue&type=script&lang=js&"
export * from "./VendorInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports